import { AbilityTypes } from "../../data/abilities";
import { Breed } from "../../engine/entity/Breed";
import { Entity } from "../../engine/entity/Entity";
import { Ability } from "../abilities/Ability";
import { promptForAbility, promptForTarget } from "../abilities/abilityUtils";
import { TargetOptions } from "../abilities/Target";
import { Actor } from "../actors/Actor";
import { gameData } from "../GameManager";

export class ItemBreed extends Breed {
  mandatory = false;
  collectOnEmpty = true;
  furniture = false;
  wearable?: string;

  useAbility: Ability | undefined;

  interactAbility: Ability | undefined;

  constructor(key: string, breedData: any) {
    super(key, breedData);
    this.furniture = breedData.furniture;
    this.collectOnEmpty =
      breedData.collectOnEmpty != null ? breedData.collectOnEmpty : true;

    if (breedData.use) {
      this.useAbility =
        typeof breedData.use === "string"
          ? AbilityTypes[breedData.use as keyof typeof AbilityTypes]
          : new Ability(breedData.use.name, breedData.use);
    }
  }
}

export const BASIC_STATS = ["health"] as const;

export class Item extends Entity<ItemBreed> {
  everHeld = false; //If item was ever held for loot spawn purposes
  uses = 1;

  constructor(id: number, breed: ItemBreed, x?: number, y?: number) {
    super(id, breed, x, y);
  }

  isUsable() {
    return this.breed.useAbility != null && this.uses > 0;
  }

  getUseTarget() {
    return this.breed.useAbility?.target;
  }

  async useItem(actor: Actor) {
    const ability = this.breed.useAbility;
    if (ability) {
      if (this.uses > 0) {
        if (ability?.target) {
          let options = ability.target.validate(actor);
          if (!options.valid) return;
          options = await promptForTarget(ability, actor, options);
          if (!options.valid) return;
          options = await promptForAbility(ability, actor, options);
          if (!options.valid) return;

          if (this.uses) {
            this.uses -= 1;
            if (this.uses <= 0) {
              if (this.breed.furniture) {
                gameData.items.remove(this.id);
              } else {
                actor.contains.remove(this.id);
              }
            }
          }
          ability.apply(actor, options);
        }
      }
    }
  }

  async interact(actor: Actor, target: TargetOptions) {
    if (this.breed.interactAbility) {
      if (this.uses > 0) {
        this.uses -= 1;
        await this.breed.interactAbility.apply(actor, target);
      }
    }
  }
}
